import moment from "moment-timezone";
import { DayOfWeek } from "../interfaces";

const chatFullFormat: Intl.DateTimeFormatOptions = {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric",
  hour12: true,
};
const chatTodayFormat: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "numeric", hour12: true };

export const addYears = (date: Date, years: number): Date => {
  const result = new Date(date);
  result.setFullYear(result.getFullYear() + years);
  return result;
};

export const addDays = (date: Date, days: number): Date => {
  if (date === undefined || date === null) {
    return new Date();
  }
  const result = new Date(date);
  result.setDate(result.getDate() + days);

  if (days > 0) {
    result.setMonth(result.getDate() < date.getDate() ? date.getMonth() + 1 : date.getMonth());
    result.setFullYear(result.getMonth() < date.getMonth() ? date.getFullYear() + 1 : date.getFullYear());
  } else {
    result.setMonth(result.getDate() > date.getDate() ? date.getMonth() - 1 : date.getMonth());
    result.setFullYear(result.getMonth() > date.getMonth() ? date.getFullYear() - 1 : date.getFullYear());
  }

  return result;
};

export const nextWeekDay = (days: number = 1): Date => {
  let day = moment().add(1, "hour");
  for (let i = 0; i < days; i++) {
    if (day.day() === 5) {
      day = day.add(3, "days");
    } else if (day.day() === 6) {
      day = day.add(2, "days");
    } else {
      day = day.add(1, "days");
    }
  }
  day.set({ minute: 0, second: 0, millisecond: 0 });
  return day.toDate();
};

export function promptSpecificDate(
  deliveryDateUtc: Date | string | null,
  deliveryTimeUtc: Date | string | null
): string | null {
  const timeZone = moment.tz.guess();
  const deliveryTimeMoment = moment(deliveryTimeUtc).tz(timeZone);
  const deliveryDateMoment = moment(deliveryDateUtc).tz(timeZone);

  const mergedDateM = moment({
    year: deliveryDateMoment.year(),
    month: deliveryDateMoment.month(),
    date: deliveryDateMoment.date(),
    hours: deliveryTimeMoment.hours(),
    minutes: deliveryTimeMoment.minutes(),
  });

  return moment.utc(mergedDateM).format();
}

export function serverDateUTCToDate(dateUtc: string | null): Date {
  const dateUtcT = moment.utc(dateUtc, "YYYY-MM-DDTHH:mm:ssZ").add(9, "hours");
  return new Date(dateUtcT.format());
}

function isPassDay(date?: string): boolean {
  if (date === undefined || date === "") {
    return true;
  }

  const today = new Date();
  const dateToCompare = new Date(date);

  today.setHours(0, 0, 0, 0);
  dateToCompare.setHours(0, 0, 0, 0);

  return !(
    today.getDate() === dateToCompare.getDate() &&
    today.getMonth() === dateToCompare.getMonth() &&
    today.getFullYear() === dateToCompare.getFullYear()
  );
}

export function printDateWithTimeZone(date?: string): string {
  if (date === "" || date === undefined || date === null) {
    return "-";
  }

  return moment(date).tz(moment.tz.guess()).format("MM/DD/YYYY hh:mm a z");
}

export function printDateTime(date: string | undefined): string {
  if (date === "" || date === undefined) {
    return "-";
  }

  const dateString = moment(date).format("MMM D [at] h:mm a");

  return dateString;
}

export function printOnlyDate(date?: string): string {
  if (!date) {
    return "-";
  }
  return moment(date).format("MMM DD, YYYY");
}

export function printBasicDate(date?: string): string {
  if (!date) {
    return "-";
  }
  return moment(date).format("MM/DD/YYYY");
}

export function printBasicShortDate(date?: string): string {
  if (!date) {
    return "-";
  }
  return moment(date).format("MM/DD/YY");
}

export function printDate(date?: string): string {
  if (date === undefined) {
    return "-";
  }
  return new Date(date).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

export function printDateToChat(date?: string): string {
  if (date === undefined) {
    return "-";
  }
  return isPassDay(date)
    ? new Date(date).toLocaleString("en-US", chatFullFormat!!)
    : "Today " + new Date(date).toLocaleString("en-US", chatTodayFormat);
}

export const getDayOfWeekState = (selected: DayOfWeek[]) => {
  const defaultSelected = false; // selected.length === 0;
  const daysStatus = {
    [DayOfWeek.Monday]: defaultSelected,
    [DayOfWeek.Tuesday]: false,
    [DayOfWeek.Wednesday]: defaultSelected,
    [DayOfWeek.Thursday]: false,
    [DayOfWeek.Friday]: defaultSelected,
    [DayOfWeek.Saturday]: false,
    [DayOfWeek.Sunday]: false,
  };

  selected.forEach((dayOfWeek: DayOfWeek) => {
    daysStatus[dayOfWeek] = true;
  });

  return daysStatus;
};
export const pstTimeToDate = (currentTime?: string): Date | undefined => {
  if (currentTime) {
    const timesArray = currentTime.split(":");
    const now = moment().tz("America/Los_Angeles");
    now.set({ hour: Number(timesArray[0]), minute: Number(timesArray[1]) });
    return now.clone().tz(moment.tz.guess()).toDate();
  }

  return undefined;
};

export const formatVideoProjectStatusDate = (statusDate?: string | null): string => {
  const date = statusDate ? moment(statusDate) : undefined;
  return date?.isValid() ? date.format("MMM DD, YY [at] hh:mm a") : "";
};
